import { useQuery } from '@tanstack/react-query';
import API from 'api/API';
import { QueryKeys } from 'api/models/QueryKeys';
import { GetLastDmInspectionParams } from 'api/models/Sets';

export const useLastDmInspection = (params: GetLastDmInspectionParams) => {
  const query = useQuery({
    queryKey: [QueryKeys.LastDmInspectionParams, params],
    queryFn: async () => API.deliveries.getLastDmInspection(params),
    enabled: Boolean(params.trayInstanceId),
  });

  return {
    ...query,
    isLoading: query.isFetching, // the query is only enabled when params are available is defined so technically it's not loading
  };
};
